import type { LogLine } from '@/lib/logcat/parser';
import type { LogcatLineView } from '@checkpoint-core';

type LevelChar = 'V' | 'D' | 'I' | 'W' | 'E' | 'F' | 'A';
const LEVELS = new Set<string>(['V', 'D', 'I', 'W', 'E', 'F', 'A']);

/**
 * 把 web 端 logcat parser 解析出的 LogLine 适配成 core 引擎的
 * LogcatLineView。如果 LogLine 带 id（useLogcatStream 注入的全局序号），
 * 直接复用作为 RunnerSet 的 lineId，让 SPA 行内 marker 可以按 line.id
 * 直接查命中；否则交给 RunnerSet 自增分配。
 */
export function convertLogLine(
  line: LogLine,
  fallbackTsMs: number = Date.now(),
): LogcatLineView | Omit<LogcatLineView, 'lineId'> {
  const level: LogcatLineView['level'] = LEVELS.has(line.level)
    ? (line.level as LevelChar)
    : '?';
  const base: Omit<LogcatLineView, 'lineId'> = {
    ts: line.ts,
    tsMs: fallbackTsMs,
    level,
    tag: line.tag,
    msg: line.message,
    raw: line.raw,
    pid: line.pid || undefined,
    tid: line.tid || undefined,
  };
  if (typeof line.id === 'number') {
    return { ...base, lineId: line.id };
  }
  return base;
}
